import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUsers, deleteUser } from '../../actions/userActions'; // Load actions
import { useNavigate } from 'react-router-dom'; // For navigation
import userService from '../../services/userAPI';
import ChangePasswordModal from './ChangePasswordModal'; // Reusable modal
import { toast } from 'react-toastify';
import { toastOptions } from "../../config/toastifyConfig";


function UserList() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Navigation for edit

  const userStore = useSelector(state => state.userList);

  // State for password modal
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Load users on component mount
  useEffect(() => {
    dispatch(loadUsers());
  }, [dispatch]);

  // Refresh user list after updates
  const refreshUsers = () => {
    dispatch(loadUsers());
  };

  // Open password reset modal
  const handleOpenPasswordModal = (userId) => {
    setSelectedUserId(userId);
    setShowPasswordModal(true);
  };

  // Handle password reset action
  const handlePasswordReset = async (oldPassword, newPassword) => {
    if (selectedUserId) {
      try {
        console.log("new pass:" + newPassword + " for user:" + selectedUserId);
        await userService.resetPasswordByAdmin(selectedUserId, newPassword);
        toast.success('Hasło zostało zresetowane pomyślnie!', toastOptions);
        refreshUsers(); // Refresh users
      } catch (error) {
        toast.error('Błąd podczas resetowania hasła.', toastOptions);
        console.error('Password reset error:', error);
      }
    }
  };

  // Edit user
  const handleEditUser = (userId) => {
    navigate(`/users/edit/${userId}`);
  };

  // Delete user
  const handleDeleteUser = async (userId) => {
    if (window.confirm('Czy na pewno chcesz usunąć tego użytkownika?')) {
      try {
        await dispatch(deleteUser(userId));
        toast.success('Użytkownik został usunięty.', toastOptions);
        refreshUsers(); // Refresh list after deletion
      } catch (error) {
        toast.error('Błąd podczas usuwania użytkownika.', toastOptions);
        console.error('Delete error:', error);
      }
    }
  };

  return (
    <div>
      {!userStore ? (
        <p>Ładowanie użytkowników...</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Nazwa</th>
              <th>Imię</th>
              <th>Nazwisko</th>
              <th>Email</th>
              <th>Role</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {userStore.map(user => (
              <tr key={user.id}>
                <td>{user.userName}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.email}</td>
                <td>{(user.roles || []).join(', ')}</td>
                <td>
                  <div className="btn-group btn-group-sm" role="group">
                    {/* Edit Button */}
                    <button
                      className="btn btn-warning"
                      onClick={() => handleEditUser(user.id)}
                    >
                      Edytuj
                    </button>

                    {/* Delete Button */}
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDeleteUser(user.id)}
                    >
                      Usuń
                    </button>

                    {/* Password Reset Button */}
                    <button
                      className="btn btn-primary"
                      onClick={() => handleOpenPasswordModal(user.id)}
                    >
                      Hasło
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Password Reset Modal */}
      <ChangePasswordModal
        show={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSubmit={handlePasswordReset}
      />
    </div>
  );
}

export default UserList;
